import {SHOW_MSG} from "../types";
import call from './call';
import languages from "../language/languages";

export default () => async (dispatch,getState) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
            dispatch({type: SHOW_MSG, payload: {message: languages[getState().auth.language].processOk,type:'success'}});
    }
    dispatch(call("SystemService/testSMTP",{},onResult));
};